/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React from "react";
import { Outlet } from "react-router-dom";
import SideBar from "./Sidebar";
import { useDispatch, useSelector } from "react-redux";

export default function Layout() {
    const auth = useSelector((state) => state.auth);
    const { userType } = auth;

    return (
        <>
            <div className="bg-[#FFFFFF]">
        
                <div className="flex h-screen w-[100vw]">
                    <SideBar role={userType} />
                    <Outlet />
                </div>
            </div>
        </>
    );
}
